class ProductAnimations {
  constructor() {
    this.initCalloutAnimation();
    this.initDraggableLists();
  }

  initCalloutAnimation() {
    document.querySelectorAll('.callout-wrapper').forEach((wrapper) => {
      const calloutItems = wrapper.querySelectorAll('.callout-item');

      calloutItems.forEach((item) => {
        const question = item.querySelector('.callout-title');
        const answer = item.querySelector('.callout-description');

        question?.addEventListener('click', () => {
          calloutItems.forEach((otherItem) => {
            if (otherItem !== item) {
              gsap.to(otherItem.querySelector('.callout-description'), {
                height: 0,
                duration: 0.3,
                onComplete: () => otherItem.classList.remove('active'),
              });
            }
          });

          item.classList.toggle('active');
          gsap.to(answer, {
            height: item.classList.contains('active') ? 'auto' : 0,
            duration: 0.3,
          });
        });
      });
    });

    document.querySelectorAll('.accordion-wrapper').forEach((wrapper) => {
      const accordionItems = wrapper.querySelectorAll('.accordion-item');
      const isMobile = () => window.innerWidth < 768;

      function setupAriaAttributes(item, isFirstItem = false) {
        const button = item.querySelector('.accordion-header');
        const content = item.querySelector('.accordion-content');

        if (!button || !content) return;

        // Set up button attributes
        button.setAttribute('type', 'button');
        button.setAttribute('aria-controls', content.id || `content-${Math.random().toString(36).slice(2)}`);

        // Set up content attributes
        if (!content.id) content.id = button.getAttribute('aria-controls');
        content.setAttribute('role', 'region');
        content.setAttribute('aria-labelledby', button.id || `button-${Math.random().toString(36).slice(2)}`);
        if (!button.id) button.id = content.getAttribute('aria-labelledby');

        // Set initial states for mobile
        if (isMobile()) {
          button.setAttribute('aria-expanded', isFirstItem ? 'true' : 'false');
        } else {
          // Remove ARIA attributes on desktop as content is always visible
          button.removeAttribute('aria-expanded');
          content.removeAttribute('role');
          content.removeAttribute('aria-labelledby');
          button.removeAttribute('aria-controls');
        }
      }

      // Initial setup
      accordionItems.forEach((item, index) => {
        setupAriaAttributes(item, index === 0);
      });

      // Handle click events
      accordionItems.forEach((item) => {
        const button = item.querySelector('.accordion-header');
        const content = item.querySelector('.accordion-content');

        button?.addEventListener('click', () => {
          // Only handle accordion behavior on mobile
          if (!isMobile()) return;

          // Close other items
          accordionItems.forEach((otherItem) => {
            if (otherItem !== item) {
              const otherButton = otherItem.querySelector('.accordion-header');
              otherButton?.setAttribute('aria-expanded', 'false');
              otherItem.classList.remove('active');

              gsap.to(otherItem.querySelector('.accordion-content'), {
                height: 0,
                duration: 0.3
              });
            }
          });

          // Toggle current item
          const isExpanding = !item.classList.contains('active');
          button.setAttribute('aria-expanded', isExpanding);
          item.classList.toggle('active');

          gsap.to(content, {
            height: isExpanding ? 'auto' : 0,
            duration: 0.3
          });
        });
      });

      // Handle resize events
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if (!isMobile()) {
            // On desktop: Remove accordion behavior
            accordionItems.forEach(item => {
              const button = item.querySelector('.accordion-header');
              const content = item.querySelector('.accordion-content');

              // Remove aria-expanded on desktop
              button?.removeAttribute('aria-expanded');
              content.style.height = '100%';
            });
          } else {
            // On mobile: Restore accordion behavior
            accordionItems.forEach((item, index) => {
              const button = item.querySelector('.accordion-header');
              const content = item.querySelector('.accordion-content');
              const isFirst = index === 0;

              button?.setAttribute('aria-expanded', isFirst);
              content.style.height = isFirst ? 'auto' : '0';
              item.classList.toggle('active', isFirst);
            });
          }
        }, 100);
      });
    });
  }

  initDraggableLists() {
    const dragSpeed = window.innerWidth > 768 ? 700 : 100;
    initDraggableList('.product-ingredients-list', '.product-ingredients-wrapper', dragSpeed);
    initDraggableList('.ig-embeds', '.ig-embed-wrapper');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ProductAnimations();

  const thumbsSwiper = new Swiper('.product-thumbs', {
    freeMode: true,
    watchSlidesProgress: true,
    allowTouchMove: false,
    slidesPerView: 'auto',
  });

  new Swiper('.product-swiper', {
    direction: 'horizontal',
    mousewheel: true,
    slidesPerView: 1,
    loop: true,
    speed: 300,
    keyboard: { enabled: true },
    pagination: { el: '.swiper-pagination' },
    thumbs: { swiper: thumbsSwiper },
  });

  // PDP Buy Card v2 toggle/CTA sync now lives inside snippets/pdp-buy-button.liquid
  // so the same handler runs everywhere the snippet renders (PDP, landing hero,
  // listicle CTA). Don't re-bind here.

  if (window.instgrm) window.instgrm.Embeds.process();
});



const originalPrices = {};

// Store the initial prices on page load
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-price]').forEach(priceElement => {
    const priceType = priceElement.dataset.price; // 'compare' or 'original'
    if (priceType) {
      originalPrices[priceType] = priceElement.innerHTML;
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.show-reviews') || document.querySelector('.coming-soon')) {
    const style = document.createElement('style');
    style.innerHTML = '.yotpo-widget-instance { display: none !important; }';
    document.head.appendChild(style);
  }

  document.querySelector('.go-to-reviews')?.addEventListener('click', () => {
    globalLenis.scrollTo('#yotpo-reviews-main-widget', { duration: 2, offset: -100 });
  });

  if (window.location.hash === '#yotpo-reviews-main-widget') {
    let attempts = 0;
    const tryScroll = () => {
      const target = document.querySelector('#yotpo-reviews-main-widget');
      if (target) {
        globalLenis.scrollTo(target, { duration: 2, offset: -100 });
      } else if (attempts++ < 30) {
        setTimeout(tryScroll, 100);
      }
    };
    tryScroll();
  }

  document.querySelector('.go-to-top')?.addEventListener('click', () => {
    globalLenis.scrollTo('#subscribe-and-save', { duration: 2, offset: -100 });
  });
});
